import React, { useEffect, useState, useContext, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AdminLayout from "../../../../layouts/admin/AdminLayout";
import AppContext from "../../../../context/AppContext";
import "../../../../assets/css/admin/dashboardcss/Escategories.css";
import axios from "axios";
import { checkLoggedInAdmin } from "../../../../helper/CustomHelper";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Categories() {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const navigate = useNavigate();
  // STATES
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editCategory, setEditCategory] = useState(null);

  // ✅ Loading states
  const [isOpeningAdd, setIsOpeningAdd] = useState(false);
  const [isSaving, setIsSaving] = useState(false);


const createCategory = () => {
  if (!title.trim() || !description.trim() || !image) {
    Swal.fire({
      icon: "warning",
      title: "Missing Information",
      text: "Please fill in the title, description and select an image before saving.",
      confirmButtonColor: "#e0456e",
    });
    return;
  }
    setIsSaving(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("file", image);

    axios
      .post(`${baseUrl}/admin/category/addNewCategory`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
  console.log(response.data);

  Swal.fire({
    icon: "success",
    title: "Category Added!",
    text: "Category has been added successfully.",
    confirmButtonColor: "#e0456e",
  });

  viewAllCategories();
  setShowAddModal(false);

  setTitle("");
  setDescription("");
  setImage(null);
})
      // .then((response) => {
      //   console.log(response.data);

      //   viewAllCategories();

      //   setShowAddModal(false);

      //   setTitle("");
      //   setDescription("");
      //   setImage(null);
      // })

      // .catch((error) => {
      //   console.log(error);
      // });
      .catch((error) => {
  console.log(error);

  Swal.fire({
    icon: "error",
    title: "Failed!",
    text: error.response?.data?.message || "Unable to add category.",
    confirmButtonColor: "#e0456e",
  });
});
  };

  // UPDATE CATEGORY
  const updateCategory = () => {
    const formData = new FormData();

    formData.append("id", editCategory.id);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("file", image);

    axios
      .post(`${baseUrl}/admin/category/updateCategory`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
  console.log(response.data);

  Swal.fire({
    icon: "success",
    title: "Category Updated!",
    text: "Category has been updated successfully.",
    confirmButtonColor: "#e0456e",
  });

  viewAllCategories();
  setShowEditModal(false);

  setTitle("");
  setDescription("");
  setImage(null);
})
      // .then((response) => {
      //   console.log(response.data);

      //   viewAllCategories();

      //   setShowEditModal(false);

      //   setTitle("");
      //   setDescription("");
      //   setImage(null);
      // })

      .catch((error) => {
        console.log(error);
      });
  };

  // VIEW ALL CATEGORIES
  const viewAllCategories = () => {
    axios
      .get(`${baseUrl}/admin/category/viewAllCategories`)

      .then((response) => {
        console.log(response.data);

        setCategories(response.data);
      })

      .catch((error) => {
        console.log(error);
      });
  };

  // DELETE CATEGORY
  const deleteCategory = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "This category will be permanently deleted.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#e0456e",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .post(`${baseUrl}/admin/category/deleteCategory`, {
          id: id,
        })
        .then((response) => {
          console.log(response.data);

          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Category has been deleted successfully.",
            confirmButtonColor: "#e0456e",
          });

          viewAllCategories();
        })
        .catch((error) => {
          console.log(error);

          Swal.fire({
            icon: "error",
            title: "Failed!",
            text:
              error.response?.data?.message ||
              "Unable to delete category.",
            confirmButtonColor: "#e0456e",
          });
        });
    }
  });
};
  // const deleteCategory = (id) => {
  //   axios
  //     .post(`${baseUrl}/admin/category/deleteCategory`, {
  //       id: id,
  //     })

  //     .then((response) => {
  //       console.log(response.data);

  //       viewAllCategories();
  //     })

  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // PAGE LOAD
  useEffect(() => {
    checkLoggedInAdmin(navigate);
    viewAllCategories();
  }, []);

  // OPEN ADD MODAL (with loading)
  const openAddModal = () => {
    setIsOpeningAdd(true);

    setTimeout(() => {
      setTitle("");
      setDescription("");
      setImage(null);

      setShowAddModal(true);
      setIsOpeningAdd(false);
    }, 300);
  };

  return (
    <AdminLayout>
      <div className="categories-page">
        <Container fluid className="px-4 px-md-5">
          {/* HEADER */}
          <Row className="align-items-center page-header">
            <Col>
              <h1 className="page-title">Categories</h1>
              <p className="page-subtitle">
                Group treatments into categories for a clean, organised menu
                across the site.
              </p>
            </Col>

            <Col xs="auto">
              <button
                className="btn-add-category"
                onClick={openAddModal}
                disabled={isOpeningAdd}
              >
                <span className="plus-icon">+</span>
                {isOpeningAdd ? "Opening..." : "Add Category"}
              </button>
            </Col>
          </Row>

          {/* CARDS */}
          <Row className="g-4">
            {categories.map((item) => (
              <Col key={item.id} xs={12} md={6}>
                <div className="category-card">
                  <div className="card-image-wrapper">
                    <img
                      src={`${baseUrlForFile}${item.image}`}
                      alt={item.title}
                    />
                    {/* <div className="services-badge">
                      {item.services ?? 0} services
                    </div> */}
                  </div>

                  <div className="card-body-content">
                    <h2 className="card-category-title">{item.title}</h2>
                    <p className="card-category-desc">{item.description}</p>
                  </div>

                  <div className="card-actions">
                    <button
                      className="btn-action"
                      onClick={() => {
                        setEditCategory(item);

                        setTitle(item.title);
                        setDescription(item.description);

                        setShowEditModal(true);
                      }}
                    >
                      Edit
                    </button>

                    <button
                      className="btn-action"
                      onClick={() => deleteCategory(item.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* ADD MODAL */}
      {showAddModal && (
        <>
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              zIndex: 1040,
            }}
            onClick={() => !isSaving && setShowAddModal(false)}
          />

          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              zIndex: 1050,
              width: "100%",
              maxWidth: 500,
              background: "#fff",
              borderRadius: 12,
              padding: "32px",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <h5 style={{ marginBottom: 20, fontWeight: 700 }}>Add Category</h5>

            <div style={{ marginBottom: 16 }}>
              <label>Image</label>
              <input
                type="file"
                style={{ display: "block", marginTop: 6, width: "100%" }}
                onChange={(e) => setImage(e.target.files[0])}
                disabled={isSaving}
              />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label>Title</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                disabled={isSaving}
                style={{
                  display: "block",
                  marginTop: 6,
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  fontSize: 14,
                }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label>Description</label>
              <textarea
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                disabled={isSaving}
                style={{
                  display: "block",
                  marginTop: 6,
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  fontSize: 14,
                  resize: "vertical",
                }}
              />
            </div>

            <div
              style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}
            >
              <button
                onClick={() => setShowAddModal(false)}
                disabled={isSaving}
                style={{
                  padding: "9px 20px",
                  borderRadius: 8,
                  border: "1px solid #ddd",
                  background: "#fff",
                  cursor: "pointer",
                  fontSize: 14,
                }}
              >
                Cancel
              </button>

              <button
                onClick={createCategory}
                disabled={isSaving}
                style={{
                  padding: "9px 20px",
                  borderRadius: 8,
                  border: "none",
                  background: "#e0456e",
                  color: "#fff",
                  cursor: isSaving ? "not-allowed" : "pointer",
                  fontSize: 14,
                  fontWeight: 600,
                  opacity: isSaving ? 0.7 : 1,
                }}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </>
      )}

      {/* EDIT MODAL */}
      {showEditModal && editCategory && (
        <>
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              zIndex: 1040,
            }}
            onClick={() => setShowEditModal(false)}
          />

          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              zIndex: 1050,
              width: "100%",
              maxWidth: 500,
              background: "#fff",
              borderRadius: 12,
              padding: "32px",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <h5 style={{ marginBottom: 20, fontWeight: 700 }}>Edit Category</h5>

            <div style={{ marginBottom: 16 }}>
              <label>Image</label>
              <input
                type="file"
                style={{ display: "block", marginTop: 6, width: "100%" }}
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label>Title</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={{
                  display: "block",
                  marginTop: 6,
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  fontSize: 14,
                }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label>Description</label>
              <textarea
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                style={{
                  display: "block",
                  marginTop: 6,
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  fontSize: 14,
                  resize: "vertical",
                }}
              />
            </div>

            <div
              style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}
            >
              <button
                onClick={() => setShowEditModal(false)}
                style={{
                  padding: "9px 20px",
                  borderRadius: 8,
                  border: "1px solid #ddd",
                  background: "#fff",
                  cursor: "pointer",
                  fontSize: 14,
                }}
              >
                Cancel
              </button>

              <button
                onClick={updateCategory}
                style={{
                  padding: "9px 20px",
                  borderRadius: 8,
                  border: "none",
                  background: "#e0456e",
                  color: "#fff",
                  cursor: "pointer",
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                Update
              </button>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
}